export const CONFLUENCE_PAGE_CONTRIBUTORS_OPERATION_NAME =
	'KnowledgeDiscoveryConfluencePageContributorsQuery';

export const KnowledgeDiscoveryConfluencePageContributorsQuery = `
query KnowledgeDiscoveryConfluencePageContributorsQuery($id: ID!) {
  contributorsLinkedToConfluencePageV2(pageId: $id) {
    queryResult {
      rows {
        __typename
        rowItems {
          key
          value {
            id
            data {
              __typename
              ... on AtlassianAccountUser {
                __typename
                name
                picture
                accountId
                canonicalAccountId
              }
            }
          }
        }
      }
    }
  }
}
`;
